import { MerchandiseItem } from './app';
import { OrderSerialize, Order } from '../common/merchandise/Order';

export class MobileOrderCart {
    constructor(
        readonly reserve_id: number,
        readonly items: MerchandiseItem[]
    ) {
        if (reserve_id) return;
        throw new Error('Reservation not Found.');
    }

    private get storageKey(): string {
        return `Mypage:MobileOrderCart:${this.reserve_id}`;
    }

    get orders(): readonly Order[] {
        const serialized = localStorage.getItem(this.storageKey);
        const parsed = serialized ? JSON.parse(serialized) : null;

        return parsed instanceof Array
            ? parsed
                  .map((o: OrderSerialize) => {
                      try {
                          return new Order(o, this.items);
                      } catch (e) {
                          console.warn('Invalid order skipped:', o, e);
                          return null;
                      }
                  })
                  .filter((o): o is Order => o !== null)
            : [];
    }

    private updateOrders(orders: readonly Order[]) {
        const serialized = JSON.stringify(orders);
        localStorage.setItem(this.storageKey, serialized);
    }

    clear() {
        localStorage.removeItem(this.storageKey);
    }

    get totalAmount(): number {
        return this.orders.reduce((sum, order) => sum + order.amount, 0);
    }

    get totalAmountIncludingTax(): number {
        return this.orders.reduce(
            (sum, order) => sum + order.amount_including_tax,
            0
        );
    }

    get needSeat(): boolean {
        return this.orders.some((o) => o.item.need_seat_selection);
    }

    categoryInNeedSeatItem(): string {
        const needSeatItems = this.orders.filter(
            (order) => order.item.need_seat_selection
        );
        if (!needSeatItems.length) return '';
        return needSeatItems[0].item.category;
    }

    save(order: Order) {
        if (!order.validate()) throw new Error('Invalid order.');
        const orders = [...this.orders];
        const index = orders.findIndex((o) => o.uid === order.uid);
        if (index < 0) {
            orders.push(order);
        } else {
            orders[index] = order;
        }
        this.updateOrders(orders);
    }

    remove(...orders: (Order | string)[]) {
        const targetIds = orders.map((order) =>
            order instanceof Order ? order.uid : order
        );
        const removed = this.orders.filter((o) => !targetIds.includes(o.uid));
        this.updateOrders(removed);
    }
}
